import { FC, useEffect, useState, useCallback } from "react"
import { CollectionUtil, ValidateUtil } from "src/framework/commons";
import { ArrayUtil } from "src/framework/commons/ArrayUtil";
import { InputComboBoxList, InputDate, InputInteger, InputMoney, InputText } from "src/framework/components/forms";
import { useObservable } from "src/framework/store/storeUtil";
import { configuracoesFinanceira$, errorsList$, profissoesList$ } from "../../negociacao/Financiamento";
import { CATEGORIA, FINANCEIRA_BV_ID, FINANCEIRA_SANTANDER_ID } from "../constants";
import { FormEndereco } from "../FormEndereco";
import { ICategoriaOcupacao, IConfiguracaoFinanceiraDom, IOcupacaoEmpresaRequestDom, IOcupacaoRequestDom } from "../types"

interface FormProfissaoProperties {
    dadosProfissao: IOcupacaoRequestDom | null;
    errorsList?: any[];
    isValid?: (value: boolean) => void;
    readonly?: boolean;
    isPessoaFisica?: boolean;
    isConjuge?: boolean;
    isAvalista?: boolean;
    indexAvalista?: number;
    onChange: (dados: null | IOcupacaoRequestDom) => void;
    dataNascimento: string | null;
    financeira_id: number;

}

const DEFAULT_EMPRESA: IOcupacaoEmpresaRequestDom = {
    capital_social: null,
    cnpj: null,
    data_fundacao: null,
    endereco: {
        bairro: null,
        cep: null,
        cidade: null,
        cidade_ibge: null,
        complemento: null,
        estado: null,
        logradouro: null,
        numero: null,
    },
    fantasia: null,
    faturamento_mensal: null,
    nome: null,
    telefone: null,
}

const FormProfissao: FC<FormProfissaoProperties> = ({
    dadosProfissao,
    errorsList = [],
    isAvalista = false,
    isConjuge = false,
    isPessoaFisica = false,
    indexAvalista,
    isValid,
    onChange,
    readonly = false,
    dataNascimento,
    financeira_id
}) => {
    const [categoriaState, setCategoriaState] = useState<ICategoriaOcupacao | null>(null);
    const [profissao, setProfissao] = useState<any>(null);
    const [errors, setErrors] = useState<string[]>([]);
    const financeiraConfig = useObservable<IConfiguracaoFinanceiraDom | null>(configuracoesFinanceira$);
    const profissoesList = useObservable(profissoesList$)
    // const handle

    useEffect(() => {
        const _categoria = CATEGORIA?.find((c: any) => c.id === dadosProfissao?.categoria) || null
        setCategoriaState(_categoria)
    }, [dadosProfissao?.categoria]);

    useEffect(() => {
        if (profissoesList) {
            const _profissao = profissoesList.find((p: any) => p.id === dadosProfissao?.profissao) || null
            setProfissao(_profissao)
        }
    }, [dadosProfissao?.profissao, profissoesList])

    useEffect(() => {
        // handleValidChange();
    }, [errors])

    const maskEspeciais = useCallback((str: String)=>{
        if(str){
            let _str = str;
            _str = _str.replace(/[^a-zA-Z0-9-' ]/g,"");
            return _str;
        }
        return null;
    },[dadosProfissao])

    const maskBeneficio = useCallback((str: String)=>{
        if(str){
            return str.replace(/[a-zA-ZÀ-ú]/g, '')
        }
        return null;
    },[dadosProfissao?.numero_beneficio])

    const checkBeneficio = useCallback((str: string)=>{
        if(str){
            const regex = /^(?:\d{10}|\d{3}.\d{3}.\d{3}-\d)$/gm;
            return !(regex.test(str));            
        }
        return true;
    },[dadosProfissao?.numero_beneficio])

    const checkBeneficioLength = useCallback((str: string)=>{
        const regex1 = /^\d{10}$/g;
        return regex1.test(str) ? 10 : 13;
    },[dadosProfissao?.numero_beneficio])

    const getBeneficioHelperText = () => {
        if(dadosProfissao?.numero_beneficio){
            const regex = /^(?:\d{10}|\d{3}.\d{3}.\d{3}-\d)$/gm;
            if(!regex.test(dadosProfissao?.numero_beneficio)){
                return "O número do benefício é inválido!";
            }else{
                return "";
            }
        }
        return "O número do benefício é obrigatório!";
    }

    return <div className="FormProfissao">
        <div className="row">
            <div className="X12">
                <InputComboBoxList
                    disabled={readonly}
                    label="Categoria"
                    textField="nome"
                    valueField="id"
                    value={categoriaState}
                    options={financeiraConfig?.id === FINANCEIRA_SANTANDER_ID ? CATEGORIA.filter(cat => (cat.id !== "aposentadoOuPensionista")) : CATEGORIA}
                    onChange={(_categoria) => {
                        const _state = CollectionUtil.merge({}, dadosProfissao)
                        if (_state) {
                            _state.categoria = _categoria?.id || null
                            if((isConjuge || isAvalista) && _categoria?.id === "empresario" && (!_state?.empresa || Object.keys(!_state?.empresa || {}).length === 0)){
                                _state.empresa = DEFAULT_EMPRESA;
                            }else{
                                delete _state.empresa;
                            }
                            onChange(_state)
                            setCategoriaState(_categoria)
                        }
                        // handleValidChange();
                    }}
                    error={
                        (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#categoria"))
                        || (!isAvalista && isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#ocupacao.categoria"))
                        || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#ocupacao.categoria`))
                        || (isAvalista && isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.ocupacao.categoria`))
                    }
                    onBlur={()=>{
                        if(!dadosProfissao?.categoria){
                            if(isConjuge && !isAvalista){
                                errorsList$.next([...errorsList, "pessoa_fisica.conjuge#ocupacao.categoria"])
                            }else if(!isConjuge && isAvalista){
                                errorsList$.next([...errorsList, `avalistas#${indexAvalista}#ocupacao.categoria`])
                            }else if(isConjuge && isAvalista){
                                errorsList$.next([...errorsList, `avalistas#${indexAvalista}#conjuge.ocupacao.categoria`])
                            }
                        }else{
                            if(isConjuge && !isAvalista){
                                errorsList$.next(errorsList.filter((error: any)=>error !== `pessoa_fisica.conjuge#ocupacao.categoria`))
                            }else if(!isConjuge && isAvalista){
                                errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#ocupacao.categoria`))
                            }else if(isConjuge && isAvalista){
                                errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#conjuge.ocupacao.categoria`))
                            }
                        }
                    }}
                />
            </div>

            {categoriaState && categoriaState?.id === "aposentadoOuPensionista" && (<>
                <div className="X12 M6">
                    <InputDate
                        disabled={readonly}
                        fullWidth
                        label="Início do benefício"
                        format="dd/MM/yyyy"
                        maxDate={new Date()}
                        value={dadosProfissao?.data_inicio_ocupacao}
                        onChange={(event: any) => {
                            const _state = CollectionUtil.merge({}, dadosProfissao)
                            if (_state) {
                                _state.data_inicio_ocupacao = event
                                onChange(_state)
                            }
                        }}
                        error={
                            (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#data_inicio_ocupacao"))
                            || (!isAvalista && isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#ocupacao.data_inicio_ocupacao"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#data_inicio_ocupacao`))
                            || (isAvalista && isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.data_inicio_ocupacao`))
                        }
                    />
                </div>
                <div className="X12 M6">
                    <InputMoney
                        disabled={readonly}
                        fullWidth
                        label="Valor benefício"
                        value={dadosProfissao?.renda_mensal}
                        InputProps={{
                            shrink: true
                        }}
                        onChangeValue={(newValue) => {
                            const _state = CollectionUtil.merge({}, dadosProfissao)
                            if (_state) {
                                _state.renda_mensal = newValue.numberValue
                                onChange(_state)
                            }
                            // handleValidChange();
                        }}
                        error={
                            (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#renda_mensal"))
                            || (!isAvalista && isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#ocupacao.renda_mensal"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#renda_mensal`))
                            || (isAvalista && isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.renda_mensal`))
                        }
                    />
                </div>
                <div className="X12 M6">
                    <InputText
                        helperText={getBeneficioHelperText()}
                        maxLength={checkBeneficioLength(dadosProfissao?.numero_beneficio || "")}
                        disabled={readonly}
                        fullWidth
                        label="Número do benefício"
                        value={dadosProfissao?.numero_beneficio}
                        InputProps={{
                            shrink: true
                        }}
                        onChange={(event: any) => {
                            const _state = CollectionUtil.merge({}, dadosProfissao)
                            if (_state) {
                                _state.numero_beneficio = (event?.target?.value).replace(/[a-zA-ZÀ-ú]/g, '');
                                onChange(_state)
                            }
                        }}
                        error={
                            (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#numero_beneficio"))
                            || (!isAvalista && isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#ocupacao.numero_beneficio"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#numero_beneficio`))
                            || (isAvalista && isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.numero_beneficio`))
                            || checkBeneficio(dadosProfissao?.numero_beneficio || "")
                        }
                    />
                </div>
            </>)}

            {categoriaState && (categoriaState?.id === "assalariado" || categoriaState?.id === "autonomo" || categoriaState?.id === "liberal" || categoriaState.id === "publico") && (<>
                <div className="X12 M6">
                    <InputComboBoxList
                        disabled={readonly}
                        label="Profissão"
                        textField="nome"
                        valueField="id"
                        value={profissao}
                        options={profissoesList || []}
                        onChange={(_profissao) => {
                            const _state = CollectionUtil.merge({}, dadosProfissao)
                            if (_state) {
                                _state.profissao = _profissao?.id || undefined
                                // dadosProfissao.descricao_profissao = _profissao?.nome || undefined
                                onChange(_state)
                            }
                            // handleValidChange();
                        }}
                        error={
                            (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#profissao"))
                            || (!isAvalista && isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#ocupacao.profissao"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#profissao`))
                            || (isAvalista && isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.profissao`))
                        }
                    />
                </div>
                <div className="X12 M6">
                    <InputMoney
                        disabled={readonly}
                        fullWidth
                        label="Renda mensal"
                        value={dadosProfissao?.renda_mensal}
                        onChangeValue={(newValue) => {
                            const _state = CollectionUtil.merge({}, dadosProfissao)
                            if (_state) {
                                _state.renda_mensal = newValue.numberValue
                                onChange(_state)
                            }
                        }}
                        onBlur={() => {
                            if (Number(dadosProfissao?.renda_mensal || 0) > 0) {
                                errorsList$.next(errorsList.filter(item => item !== "pessoa_fisica.ocupacao#renda_mensal"))
                            } else {
                                errorsList$.next([...errorsList, "pessoa_fisica.ocupacao#renda_mensal"])
                            }
                        }}
                        error={
                            (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#renda_mensal"))
                            || (!isAvalista && isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#ocupacao.renda_mensal"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#renda_mensal`))
                            || (isAvalista && isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.renda_mensal`))
                        }
                    />
                </div>
                <div className="X12 M6">
                    <InputDate
                        disabled={readonly}
                        fullWidth
                        label="Data início da função"
                        format="dd/MM/yyyy"
                        maxDate={new Date()}
                        value={dadosProfissao?.data_inicio_ocupacao}
                        onChange={(event: any) => {
                            const _state = CollectionUtil.merge({}, dadosProfissao)
                            if (_state) {
                                _state.data_inicio_ocupacao = event
                                onChange(_state)
                            }
                        }}
                        error={
                            (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#data_inicio_ocupacao"))
                            || (!isAvalista && isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#ocupacao.data_inicio_ocupacao"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#data_inicio_ocupacao`))
                            || (isAvalista && isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.data_inicio_ocupacao`))
                        }
                    />
                </div>
                <div className="X12 M6">
                    <InputText
                        disabled={readonly}
                        fullWidth
                        label="Telefone comercial"
                        mask="phone"
                        value={dadosProfissao?.telefone}
                        InputProps={{
                            shrink: true
                        }}
                        onChange={(event: any) => {
                            const _state = CollectionUtil.merge({}, dadosProfissao)
                            if (_state) {
                                _state.telefone = event.target.value
                                onChange(_state)
                            }
                        }}
                        error={
                            (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#telefone"))
                            || (!isAvalista && isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#ocupacao.telefone"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#telefone`))
                            || (isAvalista && isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.telefone`))
                        }
                    />
                </div>
            </>)}

            {categoriaState && categoriaState?.id === "empresario" && (<>

                {/* 
                    cnpj *
                    nome *
                    fantasia *
                    data_fundacao  *
                    telefone *
                    faturamento_mensal *
                    capital_social *
                    endereco 
                   */}

                <div className="X12 M6">
                    <InputComboBoxList
                        disabled={readonly}
                        label="Profissão *"
                        textField="nome"
                        valueField="id"
                        value={profissao}
                        options={profissoesList || []}
                        onChange={(_profissao) => {
                            const _state = CollectionUtil.merge({}, dadosProfissao)
                            if (_state) {
                                _state.profissao = _profissao?.id || undefined
                                setProfissao(_profissao)
                                onChange(_state)
                            }
                            // handleValidChange();
                        }}
                        onBlur={() => {
                            if (dadosProfissao?.profissao) {
                                errorsList$.next(errorsList.filter((error) => error !== "pessoa_fisica.ocupacao#profissao"))
                            } else {
                                errorsList$.next([...errorsList, "pessoa_fisica.ocupacao#profissao"])
                            }
                        }}
                        error={
                            (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#profissao"))
                            || (!isAvalista && isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#ocupacao.profissao"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#profissao`))
                            || (isAvalista && isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.profissao`))
                            || (isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#profissao"))
                        }
                    />
                </div>
                <div className="X12 M6">
                    <InputText
                        disabled={readonly}
                        fullWidth
                        label="CNPJ *"
                        mask="cnpj"
                        value={(dadosProfissao as any)?.empresa?.cnpj}
                        onChange={(event: any) => {
                            const _state = CollectionUtil.merge({}, dadosProfissao)
                            if ((_state as any)?.empresa) {
                                (_state as any).empresa.cnpj = event.target.value
                                onChange(_state)
                            }
                        }}
                        onBlur={() => {
                            if (!dadosProfissao?.empresa?.cnpj && !ValidateUtil.isValidCNPJ(dadosProfissao?.empresa?.cnpj || "")) {
                                if(isConjuge && !isAvalista){
                                    errorsList$.next([...errorsList, "pessoa_fisica.conjuge#ocupacao.empresa.cnpj"])
                                }else if(!isConjuge && isAvalista){
                                    errorsList$.next([...errorsList, `avalistas#${indexAvalista}#ocupacao.empresa.cnpj`])
                                }else if(isConjuge && isAvalista){
                                    errorsList$.next([...errorsList, `avalistas#${indexAvalista}#conjuge.ocupacao.empresa.cnpj`])
                                }else{
                                    errorsList$.next(errorsList.filter((error) => error !== "pessoa_fisica.ocupacao#empresa.cnpj"))
                                }
                            } else {
                                if(isConjuge && !isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `pessoa_fisica.conjuge#ocupacao.empresa.cnpj`))
                                }else if(!isConjuge && isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#ocupacao.empresa.cnpj`))
                                }else if(isConjuge && isAvalista){
                                    errorsList$.next(errorsList.filter((error: any)=>error !== `avalistas#${indexAvalista}#conjuge.ocupacao.empresa.cnpj`))
                                }else{
                                    errorsList$.next([...errorsList, "pessoa_fisica.ocupacao#empresa.cnpj"])
                                }
                            }
                        }}
                        error={
                            (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#empresa.cnpj"))
                            || (!isAvalista && isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#ocupacao.empresa.cnpj"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#ocupacao.empresa.cnpj`))
                            || (isAvalista && isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.ocupacao.empresa.cnpj`))
                            //|| (isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#empresa.cnpj"))
                        }
                    />

                </div>

                <div className="X12 M6">
                    <InputText
                        disabled={readonly}
                        fullWidth
                        label="Razão social *"
                        value={maskEspeciais((dadosProfissao as any)?.empresa?.nome)}
                        onChange={(event: any) => {
                            const _state = CollectionUtil.merge({}, dadosProfissao)
                            if ((_state as any)?.empresa) {
                                (_state as any).empresa.nome = event.target.value
                                onChange(_state)
                            }
                        }}
                        onBlur={() => {
                            if (dadosProfissao?.empresa?.nome) {
                                errorsList$.next(errorsList.filter((error) => error !== "pessoa_fisica.ocupacao#empresa.nome"))
                            } else {
                                errorsList$.next([...errorsList, "pessoa_fisica.ocupacao#empresa.nome"])
                            }
                        }}
                        error={
                            (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#empresa.nome"))
                            || (!isAvalista && isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#ocupacao.empresa.nome"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#empresa.nome`))
                            || (isAvalista && isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.empresa.nome`))
                            || (isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#empresa.nome"))
                        }
                    />

                </div>
                <div className="X12 M6">
                    <InputText
                        disabled={readonly}
                        fullWidth
                        label="Nome fantasia *"
                        value={(dadosProfissao as any)?.empresa?.fantasia}
                        onChange={(event: any) => {
                            const _state = CollectionUtil.merge({}, dadosProfissao)
                            if ((_state as any)?.empresa) {
                                (_state as any).empresa.fantasia = event.target.value
                                onChange(_state)
                            }
                        }}
                        onBlur={() => {
                            if (dadosProfissao?.empresa?.fantasia) {
                                errorsList$.next(errorsList.filter((error) => error !== "pessoa_fisica.ocupacao#empresa.fantasia"))
                            } else {
                                errorsList$.next([...errorsList, "pessoa_fisica.ocupacao#empresa.fantasia"])
                            }
                        }}
                        error={
                            (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#empresa.fantasia"))
                            || (!isAvalista && isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#ocupacao.empresa.fantasia"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#empresa.fantasia`))
                            || (isAvalista && isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.empresa.fantasia`))
                            || (isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#empresa.fantasia"))
                        }
                    />
                </div>
                <div className="X12 M6">
                    <InputDate
                        disabled={readonly}
                        fullWidth
                        label="Data de fundação *"
                        format="dd/MM/yyyy"
                        maxDate={new Date()}
                        value={dadosProfissao?.empresa?.data_fundacao}
                        onChange={(newDate: any) => {
                            const _state = CollectionUtil.merge({}, dadosProfissao)
                            if ((_state as any)?.empresa) {
                                (_state as any).empresa.data_fundacao = newDate
                                onChange(_state)
                            }
                        }}
                        /*
                        onBlur={(event: any) => {
                            let _errors: string[] = errors
                            if (event.target.value !== "" && event.target.value.length < 10) {
                                _errors.push("profissao.tempo_operacao")
                            } else {
                                _errors = _errors.filter((error) => error !== "profissao.tempo_operacao")
                            }
                            setErrors([..._errors]);
                        }}
                        */
                        onBlur={() => {
                            if (dadosProfissao?.empresa?.data_fundacao) {
                                errorsList$.next(errorsList.filter((error) => error !== "pessoa_fisica.ocupacao#empresa.data_fundacao"))
                            } else {
                                errorsList$.next([...errorsList, "pessoa_fisica.ocupacao#empresa.data_fundacao"])
                            }
                        }}
                        error={
                            (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#empresa.data_fundacao"))
                            || (!isAvalista && isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#ocupacao.empresa.data_fundacao"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#empresa.data_fundacao`))
                            || (isAvalista && isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.empresa.data_fundacao`))
                            || (isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#empresa.data_fundacao"))
                        }
                    />
                </div>
                <div className="X12 M6">
                    <InputText
                        disabled={readonly}
                        fullWidth
                        label="Telefone comercial *"
                        mask="phone"
                        value={dadosProfissao?.empresa?.telefone}
                        onChange={(event: any) => {
                            const _state = CollectionUtil.merge({}, dadosProfissao)
                            if (_state) {
                                _state.telefone = event.target.value
                                if (_state?.empresa) {
                                    _state.empresa.telefone = event.target.value
                                } 
                                onChange(_state)
                            }
                        }}
                        onBlur={() => {
                            if (dadosProfissao?.empresa?.telefone) {
                                errorsList$.next(errorsList.filter((error) => error !== "pessoa_fisica.ocupacao#telefone"))
                            } else {
                                errorsList$.next([...errorsList, "pessoa_fisica.ocupacao#telefone"])
                            }
                        }}
                        error={
                            (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#telefone"))
                            || (!isAvalista && isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#ocupacao.telefone"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#telefone`))
                            || (isAvalista && isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.telefone`))
                            || (isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#telefone"))
                        }
                    />
                </div>
                <div className="X12 M6">
                    <InputDate
                        disabled={readonly}
                        fullWidth
                        label="Data de início das atividades na empresa *"
                        format="dd/MM/yyyy"
                        value={dadosProfissao?.data_inicio_ocupacao}
                        maxDate={new Date()}
                        onChange={(newDate: any) => {
                            const _state = CollectionUtil.merge({}, dadosProfissao)
                            if (_state) {
                                _state.data_inicio_ocupacao = newDate
                                onChange(_state)

                                if (newDate){
                                    errorsList$.next(errorsList.filter((error) => error !== "pessoa_fisica.ocupacao#data_inicio_ocupacao"))
                                }
                            }
                        }}
                        onBlur={() => {
                            if (dadosProfissao?.data_inicio_ocupacao) {
                                errorsList$.next(errorsList.filter((error) => error !== "pessoa_fisica.ocupacao#data_inicio_ocupacao"))
                            } else {
                                errorsList$.next([...errorsList, "pessoa_fisica.ocupacao#data_inicio_ocupacao"])
                            }
                        }}
                        error={
                            (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#data_inicio_ocupacao"))
                            || (!isAvalista && isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#ocupacao.data_inicio_ocupacao"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#data_inicio_ocupacao`))
                            || (isAvalista && isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.data_inicio_ocupacao`))
                            || (isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#data_inicio_ocupacao"))
                        }
                    />
                </div>
                <div className="X12 M6">
                    <InputMoney
                        disabled={readonly}
                        fullWidth
                        label="Renda mensal *"
                        value={dadosProfissao?.renda_mensal}
                        onChangeValue={(newValue) => {
                            const _state = CollectionUtil.merge({}, dadosProfissao)
                            if (_state) {
                                _state.renda_mensal = newValue.numberValue
                                onChange(_state)
                            }
                        }}
                        onBlur={() => {
                            if (Number(dadosProfissao?.renda_mensal) > 0) {
                                errorsList$.next(errorsList.filter(item => item !== "pessoa_fisica.ocupacao#renda_mensal"))
                            } else {
                                errorsList$.next([...errorsList, "pessoa_fisica.ocupacao#renda_mensal"])
                            }
                        }}
                        error={
                            (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#renda_mensal"))
                            || (!isAvalista && isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#ocupacao.renda_mensal"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#renda_mensal`))
                            || (isAvalista && isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.renda_mensal`))
                            || (isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#renda_mensal"))
                        }
                    />
                </div>

                <div className="X12 M6">
                    <InputMoney
                        disabled={readonly}
                        fullWidth
                        label="Faturamento mensal *"
                        value={dadosProfissao?.empresa?.faturamento_mensal}
                        onChangeValue={(newValue) => {
                            const _state = CollectionUtil.merge({}, dadosProfissao)
                            if (_state.empresa) {
                                _state.empresa.faturamento_mensal = newValue.numberValue
                                onChange(_state)
                            }
                        }}
                        onBlur={() => {
                            if (Number(dadosProfissao?.empresa?.faturamento_mensal) > 0) {
                                errorsList$.next(errorsList.filter(item => item !== "pessoa_fisica.ocupacao#faturamento_mensal"))
                            } else {
                                errorsList$.next([...errorsList, "pessoa_fisica.ocupacao#faturamento_mensal"])
                            }
                        }}
                        error={
                            (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#faturamento_mensal"))
                            || (!isAvalista && isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#ocupacao.faturamento_mensal"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#faturamento_mensal`))
                            || (isAvalista && isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.faturamento_mensal`))
                            || (isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#faturamento_mensal"))
                        }
                    />
                </div>

                <div className="X12 M6">
                    <InputMoney
                        disabled={readonly}
                        fullWidth
                        label="Capital social *"
                        value={dadosProfissao?.empresa?.capital_social}             
                        onChangeValue={(newValue) => {
                            const _state = CollectionUtil.merge({}, dadosProfissao)
                            if (_state.empresa) {
                                _state.empresa.capital_social = newValue.numberValue
                                onChange(_state)
                            }
                        }}
                        onBlur={() => {
                            if (Number(dadosProfissao?.empresa?.capital_social) > 0) {
                                errorsList$.next(errorsList.filter(item => item !== "pessoa_fisica.ocupacao#empresa.capital_social"))
                            } else {
                                errorsList$.next([...errorsList, "pessoa_fisica.ocupacao#empresa.capital_social"])
                            }
                        }}
                        error={
                            (!isAvalista && !isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#empresa.capital_social"))
                            || (!isAvalista && isConjuge && ArrayUtil.contains(errorsList, "pessoa_fisica.conjuge#ocupacao.empresa.capital_social"))
                            || (isAvalista && !isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#ocupacao.empresa.capital_social`))
                            || (isAvalista && isConjuge && ArrayUtil.contains(errorsList, `avalistas#${indexAvalista}#conjuge.ocupacao.empresa.capital_social`))
                            || (isAvalista && ArrayUtil.contains(errorsList, "pessoa_fisica.ocupacao#empresa.capital_social"))
                        }
                    />
                </div>

                <FormEndereco
                    dadosEndereco={dadosProfissao?.empresa?.endereco || null}
                    isPessoaFisica={isPessoaFisica}
                    errorsList={errorsList}
                    indexAvalista={indexAvalista}
                    isAvalista={isAvalista}
                    isConjuge={isConjuge}
                    dataNascimento={(financeira_id === FINANCEIRA_BV_ID ? (dadosProfissao?.empresa?.data_fundacao || null) : dataNascimento) || null}
                    formProfissao={true}
                    financeira_id={financeira_id || 0}
                    isEmpresa={(financeira_id === FINANCEIRA_BV_ID ? (dadosProfissao?.empresa?.data_fundacao ? true : false) : false)}
                    onChangeData={(_dadosEndereco) => {
                        const _state = CollectionUtil.merge({}, dadosProfissao)
                        if(dadosProfissao?.categoria === "empresario" && !_state?.empresa){
                            _state.empresa = DEFAULT_EMPRESA;
                        }
                        if (_state) {
                            _state.empresa.endereco = CollectionUtil.merge(_state.empresa.endereco, _dadosEndereco);
                            onChange(_state)
                        }
                    }}
                    
                />
            </>)}
        </div>
    </div>
}

export { FormProfissao }